<template>
  <div>
    <h1 class="onboarding__title mb-10">
      {{ $t('onboarding.payment.titleSelect') }}
    </h1>

    <v-row>
      <v-col cols="12" sm="5">
        <p class="d-flex mb-0">
          {{ $t('onboarding.payment.amount') }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" class="ml-1" small>
                mdi-information-outline
              </v-icon>
            </template>
            <span>
              {{ $t('onboarding.payment.amountDescription') }}
            </span>
          </v-tooltip>
        </p>
        <p :class="`text-h4 ${$vuetify.breakpoint.mobile ? 'mb-0' : 'mb-5'}`">
          {{ formatMoney(onboardingAppointmentValue) }}
        </p>
      </v-col>
      <v-col cols="12" sm="7">
        <OnboardingTypeSelect
          v-if="paymentType"
          @paymentType="setPaymentType"
          :paymentType="paymentType"
        />
      </v-col>
    </v-row>

    <OnboardingTypeSelect v-if="!paymentType" @paymentType="setPaymentType" />

    <OnboardingCreditCard
      v-if="paymentType === 'ASAAS_CREDIT_CARD'"
      :paymentType="paymentType"
    />
    <OnboardingPix
      v-if="paymentType === 'ASAAS_PIX'"
      @clearRefreshInterval="clearRefreshInterval"
      :paymentType="paymentType"
      ref="pixPayment"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

import OnboardingTypeSelect from './paymentTypes/OnboardingTypeSelect'
import OnboardingCreditCard from './paymentTypes/OnboardingCreditCard'
import OnboardingPix from './paymentTypes/OnboardingPix'

export default {
  name: 'OnboardingStepsPayment',

  components: {
    OnboardingTypeSelect,
    OnboardingCreditCard,
    OnboardingPix,
  },

  data() {
    return {
      formatMoney: catalogMonetary,
      paymentType: '',
      _interval: '',
    }
  },

  computed: {
    ...mapGetters(['pixData', 'successData', 'onboardingAppointmentValue']),
  },

  methods: {
    ...mapActions(['handleRecharge', 'refreshPixRecharge']),
    ...mapMutations(['setRechargeFields']),

    startRefreshInterval() {
      this.interval = setInterval(() => {
        this.refreshPixRecharge(this.successData.id)
      }, 5000)
    },

    clearRefreshInterval() {
      clearInterval(this.interval)
    },

    setPaymentType(type) {
      this.paymentType = type

      if (this.paymentType === 'ASAAS_CREDIT_CARD') {
        this.clearRefreshInterval()
      }

      if (type === 'ASAAS_PIX' && !this.pixData?.status) {
        Promise.resolve(
          this.setRechargeFields({
            type: 'ASAAS_PIX',
            value: this.onboardingAppointmentValue,
          })
        )
          .then(() => this.handleRecharge())
          .then(() => this.startRefreshInterval())
      }

      if (type === 'ASAAS_PIX' && this.pixData?.status) {
        this.startRefreshInterval()
      }
    },
  },
}
</script>
